<!-- Filter bar: accounts, period, custom date range, toggles. -->
<script lang="ts">
  import * as E from "../core/engine";
  import { refreshMarket, setAccounts, setCustom, setPeriod, setPrivacy, setTax, toggleTheme } from "../lib/actions";
  import { app, PERIODS } from "../lib/state.svelte";

  const m = $derived(app.model);
  const brokers = $derived(m ? [...new Set(m.accounts.map((a) => m.acc[a].broker))] : []);
  const ccyOf = (a: string) => [...new Set((app.data?.transactions ?? []).filter((x) => x.account === a).map((x) => x.currency))].join("/");
  const nameOf = (a: string) => app.data?.config.accounts?.[a]?.name || a.replace(/^([A-Z]+)-/, "$1 ");

  function clickAcc(a: string) {
    if (!m) return;
    let s = new Set(app.accounts);
    if (s.size === m.accounts.length) s = new Set([a]);
    else if (s.has(a)) { s.delete(a); if (!s.size) s = new Set(m.accounts); }
    else s.add(a);
    setAccounts(s);
  }
  const onRange = (which: "start" | "end", v: string) => setCustom({ ...app.range, [which]: v });
</script>

<header class="top">
  <div class="filters">
    <div class="chips" id="accountChips" role="group" aria-label="Rachunki">
      {#if m}
        <button class="chip" data-acc="*" aria-pressed={app.allAccounts} onclick={() => setAccounts(new Set(m.accounts))}>Wszystkie</button>
        {#if brokers.length > 1}
          {#each brokers as b (b)}
            {@const accs = m.accounts.filter((a) => m.acc[a].broker === b)}
            <button class="chip" data-broker={b} aria-pressed={accs.every((a) => app.accounts.has(a)) && app.accounts.size === accs.length} onclick={() => setAccounts(new Set(accs))}>{b}</button>
          {/each}
        {/if}
        {#if m.accounts.length > 1}
          {#each m.accounts as a (a)}
            <button class="chip" data-acc={a} aria-pressed={app.accounts.has(a) && !app.allAccounts} onclick={() => clickAcc(a)}>{nameOf(a)} <span class="muted small">{ccyOf(a)}{m.taxExempt.has(a) ? " · bez Belki" : ""}</span></button>
          {/each}
        {/if}
      {/if}
    </div>
    <div class="seg" id="periodSeg" role="group" aria-label="Okres">
      {#if m}
        {#each PERIODS as p (p.k)}
          <button data-p={p.k} aria-pressed={app.period === p.k} onclick={() => setPeriod(p.k)}>{p.label}</button>
        {/each}
      {/if}
    </div>
    {#if m && app.period === "CUSTOM"}
      {@const min = E.addDays(m.firstDay, 1)}
      <div class="custom-range" id="customRange">
        <input type="date" id="rangeStart" aria-label="Od" value={app.range.start} {min} max={m.today} onchange={(e) => onRange("start", e.currentTarget.value)} /> –
        <input type="date" id="rangeEnd" aria-label="Do" value={app.range.end} {min} max={m.today} onchange={(e) => onRange("end", e.currentTarget.value)} />
      </div>
    {/if}
  </div>
  <div class="toggles">
    <label class="switch" title="Pokazuj wyniki po podatku Belki (19%)"><input type="checkbox" id="taxToggle" checked={!!app.tax} onchange={(e) => setTax(e.currentTarget.checked)} /><span></span>Belka</label>
    <label class="switch" title="Ukryj kwoty"><input type="checkbox" id="privacyToggle" checked={app.privacy} onchange={(e) => setPrivacy(e.currentTarget.checked)} /><span></span>Ukryj kwoty</label>
    <button class="icon-btn" class:spin={app.busy} id="refreshBtn" title="Odśwież notowania i kursy" onclick={refreshMarket}>↻</button>
    <button class="icon-btn" id="themeBtn" title="Motyw jasny/ciemny" onclick={toggleTheme}>◐</button>
  </div>
</header>
